// Utility Functions
function updateCartUI(cartData) {
  // Update cart count
  if (cartData.item_count > 0) {
    if ($('#cart-count').length === 0) {
      $('#cart-icon').after('<span id="cart-count">' + cartData.item_count + '</span>');
    } else {
      $('#cart-count').html(cartData.item_count);
    }
  } else {
    $('#cart-count').remove();
  }

  // Fetch and update cart drawer content
  fetch('/cart?view=drawer', {
    headers: {
      'Cache-Control': 'no-cache',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartContent = doc.querySelector('.cart-container');
      
      if (newCartContent) {
        const cartDrawer = document.getElementById('cart-drawer');
        const currentContainer = cartDrawer.querySelector('.cart-container');
        if (currentContainer) {
          currentContainer.innerHTML = newCartContent.innerHTML;
        }
      }
    })
    .catch(error => console.error('Error updating cart drawer:', error));
}

function toggleCart(e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  
  if (!cartDrawer) {
    console.error('Cart drawer not found');
    return;
  }

  const isHidden = cartDrawer.getAttribute('aria-hidden') === 'true';
  
  // Store scroll prevention function reference for proper cleanup
  if (!window.cartScrollPreventer) {
    window.cartScrollPreventer = function(e) {
      // Allow scrolling inside the cart drawer
      const cartContainer = document.querySelector('.cart-container');
      if (cartContainer && cartContainer.contains(e.target)) {
        return true;
      }
      // Prevent scrolling on body/overlay
      e.preventDefault();
      e.stopPropagation();
      return false;
    };
  }
  
  if (isHidden) {
    // First, open the cart drawer visually
    cartDrawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      cartDrawer.style.transform = 'translateX(0)';
      document.body.classList.add('cart-drawer-open');
      if (cartOverlay) {
        cartOverlay.style.opacity = '1';
        cartOverlay.style.visibility = 'visible';
      }
      
      // After cart is visible, trigger scroll to hide browser nav
      // Use multiple small scrolls to ensure browser recognizes it
      const currentScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      
      // Temporarily allow scrolling
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      
      // Scroll down slightly multiple times to trigger browser nav hiding
      let scrollAttempts = 0;
      const maxAttempts = 3;
      const scrollInterval = setInterval(() => {
        scrollAttempts++;
        window.scrollTo({
          top: currentScrollY + scrollAttempts,
          behavior: 'auto'
        });
        
        if (scrollAttempts >= maxAttempts) {
          clearInterval(scrollInterval);
          
          // Now lock scrolling
          setTimeout(() => {
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
            
            // Prevent scroll events on body/overlay only (not inside cart drawer)
            document.body.addEventListener('touchmove', window.cartScrollPreventer, { passive: false });
            document.body.addEventListener('wheel', window.cartScrollPreventer, { passive: false });
          }, 100);
        }
      }, 50);
    });
  } else {
    // Closing animation - restore scroll capability
    cartDrawer.style.transform = 'translateX(100%)';
    document.body.classList.remove('cart-drawer-open');
    
    // Remove scroll prevention
    document.body.removeEventListener('touchmove', window.cartScrollPreventer);
    document.body.removeEventListener('wheel', window.cartScrollPreventer);
    
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    
    if (cartOverlay) {
      cartOverlay.style.opacity = '0';
      cartOverlay.style.visibility = 'hidden';
    }
    setTimeout(() => {
      cartDrawer.setAttribute('aria-hidden', 'true');
    }, 300);
  }

  // Only fetch new cart data if we're opening the drawer and it wasn't triggered by add-to-cart
  if (isHidden && e) {
    updateCartUI({ item_count: cartDrawer.querySelectorAll('.cart-row').length });
  }
}

// Related Products Scroll Buttons
function initRelatedProductsScroll() {
  const scrollContainer = document.querySelector('.cart-related-products-scroll');
  const leftBtn = document.querySelector('.cart-scroll-left');
  const rightBtn = document.querySelector('.cart-scroll-right');
  
  if (!scrollContainer || !leftBtn || !rightBtn) return;
  
  function updateButtonStates() {
    const scrollLeft = scrollContainer.scrollLeft;
    const scrollWidth = scrollContainer.scrollWidth;
    const clientWidth = scrollContainer.clientWidth;
    const maxScroll = scrollWidth - clientWidth;
    
    // Show/hide buttons based on scroll position
    if (scrollLeft <= 0) {
      leftBtn.classList.add('disabled');
    } else {
      leftBtn.classList.remove('disabled');
    }
    
    if (scrollLeft >= maxScroll - 1) { // -1 for rounding errors
      rightBtn.classList.add('disabled');
    } else {
      rightBtn.classList.remove('disabled');
    }
    
    // Hide buttons if content doesn't overflow
    if (scrollWidth <= clientWidth) {
      leftBtn.style.display = 'none';
      rightBtn.style.display = 'none';
    } else {
      // Only show on desktop
      if (window.innerWidth >= 768) {
        leftBtn.style.display = 'flex';
        rightBtn.style.display = 'flex';
      }
    }
  }
  
  // Scroll functions
  leftBtn.addEventListener('click', function() {
    const scrollAmount = scrollContainer.clientWidth * 0.8;
    scrollContainer.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  });
  
  rightBtn.addEventListener('click', function() {
    const scrollAmount = scrollContainer.clientWidth * 0.8;
    scrollContainer.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  });
  
  // Update button states on scroll
  scrollContainer.addEventListener('scroll', updateButtonStates);
  
  // Update on resize
  window.addEventListener('resize', function() {
    updateButtonStates();
    // Hide buttons on mobile
    if (window.innerWidth < 768) {
      leftBtn.style.display = 'none';
      rightBtn.style.display = 'none';
    } else {
      updateButtonStates();
    }
  });
  
  // Initial check
  setTimeout(updateButtonStates, 100);
  
  // Watch for cart drawer open to re-check
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(function(mutations) {
      if (cartDrawer.getAttribute('aria-hidden') === 'false') {
        setTimeout(updateButtonStates, 200);
      }
    });
    
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  initRelatedProductsScroll();
});

// Also initialize when cart drawer opens (for dynamic content)
if (typeof toggleCart !== 'undefined') {
  const originalToggleCart = toggleCart;
  toggleCart = function() {
    originalToggleCart.apply(this, arguments);
    setTimeout(initRelatedProductsScroll, 300);
  };
}

// Document Ready Handler
$(document).ready(function() {
  // Basic Setup
  $('body').css('min-height', '93vh');
  
  // Search Overlay Setup
  const searchOverlay = `
    <div class="search-overlay">
      <button class="close-search">✕</button>
      <div class="search-overlay-content">
        <form action="/search" method="get" role="search">
          <input type="search" 
                 name="q" 
                 class="search-input" 
                 placeholder="Search..." 
                 aria-label="Search">
        </form>
      </div>
    </div>`;
  
  $('body').append(searchOverlay);

  // Search Event Handlers
  $('.search-icon-mobile, .search-icon').click(function(e) {
    e.preventDefault();
    $('.search-overlay').fadeIn(200);
    $('.search-overlay .search-input').focus();
    $('body').addClass('search-active');
  });

  $('.close-search').click(function() {
    $('.search-overlay').fadeOut(200);
    $('body').removeClass('search-active');
  });

  // Cart Quantity Event Handlers
  $(document).on('click', '.btn-number', function(e) {
    e.preventDefault();
    
    const fieldName = $(this).attr('data-field');
    const type = $(this).attr('data-type');
    const input = $(`#${fieldName}`);
    const currentVal = parseInt(input.val());
    const minVal = parseInt(input.attr('min')) || 0;
    const maxVal = parseInt(input.attr('max')) || 99;

    if (!isNaN(currentVal)) {
      if(type === 'minus') {
        if(currentVal > minVal) {
          input.val(currentVal - 1).change();
          // Re-enable plus button if it was disabled
          $(`.btn-number[data-type="plus"][data-field="${fieldName}"]`).removeAttr('disabled');
        }
        // Disable minus button when at minimum (0)
        if(parseInt(input.val()) === minVal) {
          $(this).attr('disabled', true);
        }
      } else if(type === 'plus') {
        if(currentVal < maxVal) {
          input.val(currentVal + 1).change();
          // Re-enable minus button if it was disabled
          $(`.btn-number[data-type="minus"][data-field="${fieldName}"]`).removeAttr('disabled');
        }
        // Disable plus button when at maximum
        if(parseInt(input.val()) === maxVal) {
          $(this).attr('disabled', true);
        }
      }
    } else {
      input.val(0);
    }
  });

  $(document).on('focusin', '.input-number', function() {
    $(this).data('oldValue', $(this).val());
  });

  // Updated quantity change handler
  $(document).on('change', '.input-number', function() {
    const minValue = parseInt($(this).attr('min'));
    const maxValue = parseInt($(this).attr('max'));
    const valueCurrent = parseInt($(this).val());
    const variantId = $(this).data('variant_id');
    
    // Validate input
    if (isNaN(valueCurrent) || valueCurrent < minValue) {
      $(this).val(minValue);
      return;
    }
    if (valueCurrent > maxValue) {
      $(this).val(maxValue);
      return;
    }

    // Send cart update request
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        updates: {
          [variantId]: valueCurrent
        }
      },
      dataType: 'json',
      success: function(cartData) {
        updateCartUI(cartData);
      },
      error: function(error) {
        console.error('Error updating cart:', error);
      }
    });
  });

  // Updated delete cart row handler
  $(document).on('click', '.delete-cart-row', function(e) {
    e.preventDefault();
    const varId = $(this).data('variant_quantity_selector');
    const variantId = $(`#${varId}`).data('variant_id');
    
    // Send cart update request
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        updates: {
          [variantId]: 0
        }
      },
      dataType: 'json',
      success: function(cartData) {
        updateCartUI(cartData);
      },
      error: function(error) {
        console.error('Error updating cart:', error);
      }
    });
  });

  $(document).on('keydown', '.input-number', function(e) {
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
        (e.keyCode === 65 && e.ctrlKey === true) || 
        (e.keyCode >= 35 && e.keyCode <= 39)) {
      return;
    }
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  });

// Image Handling
$('img').each(function() {
  // Don't lazy load if image has any of these classes or attributes
  if (!$(this).hasClass('hero-image') && 
      !$(this).hasClass('special-module-image') && 
      !$(this).hasClass('desktop-showcase-featured-image') &&
      !$(this).hasClass('collection-image') &&
      !$(this).hasClass('first-product-image') &&
      !$(this).attr('fetchpriority')) {
    
    $(this).prop('loading', 'lazy')
           .css({
             'color': 'transparent',
             '-webkit-backface-visibility': 'hidden'
           });
  } else {
    // Explicitly remove lazy loading from important images
    $(this).removeAttr('loading');
  }
});
});

// Global Event Listeners
document.addEventListener('DOMContentLoaded', function() {
  // Search Escape Key Handler
  $(document).on('keyup', function(e) {
    if (e.key === "Escape") {
      $('.search-overlay').fadeOut(200);
      $('body').removeClass('search-active');
    }
  });

  // Search Overlay Click Handler
  $(document).on('click', '.search-overlay', function(e) {
    if (!$(e.target).closest('.search-overlay-content').length) {
      $('.search-overlay').fadeOut(200);
      $('body').removeClass('search-active');
    }
  });

// Cart Event Listeners using event delegation
$(document).on('click', function(e) {
  const cartDrawer = document.getElementById('cart-drawer');
  if (!cartDrawer || cartDrawer.getAttribute('aria-hidden') === 'true') return;

  const cartContainer = cartDrawer.querySelector('.cart-container');
  const isClickOutsideCart = !cartContainer.contains(e.target);
  const isNotCartTrigger = !$(e.target).closest('.cart-trigger, .cart-close, .cart-close-inline, .btn-number, .delete-cart-row').length;

  if (isClickOutsideCart && isNotCartTrigger) {
    toggleCart();
  }
});


  $(document).on('click', '.cart-close-inline', function(e) {
    e.preventDefault();
    e.stopPropagation();
    toggleCart();
  });

  $(document).on('click', '.cart-close', function(e) {
    e.preventDefault();
    toggleCart();
  });

  // Escape key handler for cart
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
      const cartDrawer = document.getElementById('cart-drawer');
      if (cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false') {
        toggleCart();
      }
    }
  });

  // Swipe to close cart (anywhere on screen)
  let touchStartX = 0;
  $(document).on('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
  });

  $(document).on('touchend', function(e) {
    const swipeDistance = e.changedTouches[0].clientX - touchStartX;
    const cartDrawer = document.getElementById('cart-drawer');
    if (swipeDistance > 100 && cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false') {
      toggleCart();
    }
  });
});
